import { render, staticRenderFns } from "./rateOfLearning.vue?vue&type=template&id=b8525272&scoped=true"
import script from "./rateOfLearning.vue?vue&type=script&lang=js"
export * from "./rateOfLearning.vue?vue&type=script&lang=js"
import style0 from "./rateOfLearning.vue?vue&type=style&index=0&id=b8525272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8525272",
  null
  
)

export default component.exports